/* @flow */

import React from 'react';
import { Form } from 'semantic-ui-react';
import { SECURITY_CONTEXTS } from 'catalog/constants';

type Props = {
  canOverride: boolean,
  input: Object,
  meta: Object,
  label: String,
};

const SecurityContextSelector = ({
  canOverride,
  input,
  meta: { touched, error },
  label,
}: Props) => {
  const contextChanged = (_, { value }) => input.onChange(value);

  if (canOverride) {
    return (
      <Form.Select
        {...input}
        error={touched && error}
        label={label}
        onChange={contextChanged}
        options={SECURITY_CONTEXTS}
        placeholder={`Sélectionnez un contexte d'authentification`}
      />
    );
  }

  return null;
};

export default SecurityContextSelector;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/shared/components/SecurityContextSelector.js